export class CatalogItem {
    constructor(rank, title = "", free = false) {
        this.rank = rank;
        this.title = title;
        this.free = free;
    }
}